var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gallery-panel"},[_c('Post',{staticClass:"pa-6",attrs:{"item":_vm.post,"isMedia":""},on:{"onData":_vm.onData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }